@if (selectedCompanyGroup !== 'COM') {
  <div id="blocks"
    class="container logos px-4 d-flex w-100" [ngClass]="[(logos.length < 4 || selectedCompanyGroup === 'WG' ? 'justify-content-start' : 'justify-content-between'), (logos.length < 5 ? 'small-list' : 'long-list')]"
    >
    @for (brand of logos; track brand) {
      @if ((brand.bike_count > 0 || brand.type === 'parts') && brand.show) {
        <div class="d-flex align-items-center">
          <img
            class="d-block clickable withOpacity"
            [ngClass]="'logo_' + brand.name"
            height="48px"
            [src]="'./assets/images/logos/brands/' + brand.logo"
            (click)="gotoSearch(brand)"
            />
        </div>
      }
    }
  </div>
} @else {
  <div id="blocks" class="py-3 px-4" [ngClass]="selectLanguage">
    <div class="block d-flex">
      <div class="block-content d-flex align-items-center">
        <div class="block-icon me-4">
          <i class="material-icons">headset_mic</i>
        </div>
        <div class="block-text" [innerHTML]="'COMET_MARKETING_MESSAGE_1' | translate ">
        </div>
      </div>
    </div>
    <div class="block d-flex">
      <div class="block-content d-flex align-items-center">
        <div class="block-icon me-4">
          <i class="material-icons">phone</i>
        </div>
        <div class="block-text" [innerHTML]="'COMET_MARKETING_MESSAGE_2' | translate ">
        </div>
      </div>
    </div>
    <div class="block d-flex">
      <div class="block-content d-flex align-items-center">
        <div class="block-icon me-4">
          <i class="material-icons">settings</i>
        </div>
        <div class="block-text" [innerHTML]="'MARKETING_MESSAGE_3' | translate ">
        </div>
      </div>
    </div>
    @if (selectLanguage=='ES') {
      <div class="block d-flex">
        <div class="block-content d-flex align-items-center">
          <div class="block-icon me-4">
            <i class="material-icons">content_copy</i>
          </div>
          <div class="block-text" [innerHTML]="'COMET_MARKETING_MESSAGE_4' | translate ">
          </div>
        </div>
      </div>
    }
  </div>
}

